import { FormFieldType } from '~/components/Form';

export function formValidation(prop: FormFieldType, value: null | string | number) {
    let propValid = true;
    const propValidation = [];
    if (prop.rules.includes('required')) {
        if (!value || typeof value !== 'string' || value.trim() === '') {
            propValid = false;
            propValidation.push('required');
        }
    }
    if (prop.rules.includes('requireddate')) {
        if (!value || value === null) {
            propValid = false;
            propValidation.push('requireddate');
        }
    }
    if (prop.rules.includes('email')) {
        if (typeof value !== 'string' || !value.match(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-.]+$/)) {
            propValid = false;
            propValidation.push('email');
        }
    }
    if (prop.rules.includes('match')) {
        if (value !== prop.matchvalue) {
            propValid = false;
            propValidation.push('match');
        }
    }
    if (prop.rules.includes('maxLength')) {
        if (
            value &&
            typeof value === 'string' &&
            prop.maxLength &&
            value.length > Number(prop.maxLength)
        ) {
            propValid = false;
            propValidation.push('maxLength');
        }
    }
    return { propValid, propValidation };
}
